import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export interface TradingRelationshipOption {
  id: string;
  label: string;
}

/** B8: the caller tenant's trading relationships, for the fee-policy exclude-TR picker. */
export const list = () => httpRequest.get("/bil/my/trading-relationships");
